import {OnInit, Component, NgModule, NgZone} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {RouterModule, Router} from '@angular/router';
import {BrowserModule, DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {ReCaptchaModule} from "angular2-recaptcha"
import { PasswordRecoveryHttp } from '../../../tsScripts/providers/http/PasswordRecoveryHttp';
import { DEFAULT_SUBDOMAIN_TS, PRODUCT_TS, URL_PRODUCT } from '../MainComponent';
import { ErrorDTO } from '../../../tsScripts/DTO/ErrorDTO';
import { LoadingButtonModule } from '../../../tsScripts/directives/LoadingButton';
import { FloatingLabelModule } from '../../../tsScripts/directives/FloatingLabel';
import { TokenStorage } from 'providers/TokenStorage';

declare let RECAPTCHA_GOOGLE_SITE_KEY: string;
declare let userInterface:any;
@Component({
    selector: 'password-recovery',
    templateUrl: "../../../views/components/passwordRecovery/passwordRecovery.html",
    providers: [PasswordRecoveryHttp],
    styleUrls: ["../../../styles/password-recovery.css"]
})
export class PasswordRecovery implements OnInit {

    PRODUCT: any;
    loading: boolean;
    subDomain: string;
    alertMessage: string;
    typeAlert: string;
    email: string;
    captchaResult: boolean;
    URL_PRODUCT_SAFE: SafeUrl;
    URL_PRODUCT: string;
    RECAPTCHA_GOOGLE_SITE_KEY: string;
    userInterface:any=userInterface;

    constructor(private zone: NgZone,
        private PasswordRecoveryHttp: PasswordRecoveryHttp,
        private sanitizer: DomSanitizer,
        private router: Router,
        private tokenStorage: TokenStorage) {
        this.loading = false;
        this.alertMessage = "";
        this.captchaResult = true;
        this.subDomain = DEFAULT_SUBDOMAIN_TS;
        this.PRODUCT = PRODUCT_TS;
        this.URL_PRODUCT = URL_PRODUCT;
        this.URL_PRODUCT_SAFE = this.sanitizer.bypassSecurityTrustResourceUrl(this.URL_PRODUCT);
        this.RECAPTCHA_GOOGLE_SITE_KEY = RECAPTCHA_GOOGLE_SITE_KEY;
    }

    sendToken() {
        this.zone.run(() => {
            this.alertMessage = "";
            this.typeAlert = "";
            if (this.email != null && this.email.toString() != "") {
                this.loading = true;
                let param: any = {
                    product: this.PRODUCT.NAME,
                    company: this.subDomain,
                    username: this.email.toString()
                }
                this.PasswordRecoveryHttp.sendToken(param).subscribe((response: any) => {
                    this.loading = false;
                    this.router.navigate(['/password/recovery/linkSent'], {queryParams: {email: this.email.toString()}});
                }, (error: ErrorDTO) => {
                    this.alertMessage = error.errorMessage;
                    this.typeAlert = "error";
                    this.loading = false;
                    this.email = "";
                });
            } else {
                this.alertMessage = "Necesita completar todos los campos";
                this.typeAlert = "warning";
            }
        });
    }

    handleCorrectCaptcha(response: string) {
        (response != '') ? this.captchaResult = false : this.captchaResult = true;
    }

    ngOnInit() {
        let bg_login_class = {
            "background": `url(${this.PRODUCT.BACKGROUND_LOGIN}) no-repeat fixed center center`,
            "background-size": "cover",
            "background-attachment": "fixed"
        };
        $('.login-background').css(bg_login_class);
        this.tokenStorage.verifyCookieAndLocalStorage();
    }

}

@NgModule({
    declarations: [PasswordRecovery],
    imports: [FormsModule, BrowserModule, LoadingButtonModule, RouterModule, FloatingLabelModule, ReCaptchaModule],
    providers: [],
    entryComponents: [],
    exports: []
})
export class PasswordRecoveryModule {
}